import useRouter from '~/client/hooks/router/useRouter';

const useGameParams = () => {
  const router = useRouter();
  const handle = router.query.handle as Maybe<string>;
  const categoryHandle = router.query.category as Maybe<string>;
  return { categoryHandle, handle };
};

export default useGameParams;
